export interface ILocationMaster {
  id?: number;
  name?: string | null;
  value?: string | null;
}

export const defaultValue: Readonly<ILocationMaster> = {};
